<template>
  <client-only>
    <div class="market-container" style="display: contents">
      <template v-for="block in blocks">
        <component
          :is="block.component"
          :key="block._uid"
          v-editable="block"
          v-bind="block"
          :storyblok-uid="block._uid"
        />
      </template>
    </div>
  </client-only>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'MarketContainer',
  props: {
    markets: {
      type: Array,
      required: true
    },
    content: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      currentMarketId: 'frontend/currentMarketId'
    }),
    blocks () {
      // Use this method to filter out if the block should display
      // depending on market, if it should use a default one or not etc
      return this.content.filter(() => {
        return !this.markets.length || this.markets.includes(this.currentMarketId.toString())
      }) || []
    }
  },
}
</script>